export default api => ({
    get: ({ entityKey, params }) => api.get(`/outputs/${entityKey}/ag-grid`, params),
    post: ({ entityKey, params }) => api.post(`/outputs/${entityKey}/ag-grid`, params),
    update: ({ entityKey, fieldKey, ...params }) => api.put(`/outputs/${entityKey}/fields/${fieldKey}`, params),
    edit: ({ entityKey, fieldKey, ...params }) => api.put(`/outputs/${entityKey}/edit`, params),
    historic: ({
        entityKey, rowKey, fieldKey, ...params
    }) => api.get(`/outputs/${entityKey}/${rowKey}/${fieldKey}/sources`, params),

    detail: ({ entityKey, id, resource }) => api.get(`/outputs/${entityKey}/${id}/${resource}`),
    delete: ({ entityKey, id }) => api.delete(`/outputs/${entityKey}/${id}`),
    deleteMultiple: ({ entityKey, params }) => api.delete(`/outputs/${entityKey}`, params),
})
